import { create } from '@theme/create';

export const themed = create(
  new (function () {
    this.wrapper = {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      gap: 11,
    };

    // todo: nested variants should really be button variants that modify primary
    // so that they can be used through a project and not just here
    this.button = {
      variant: 'primary',
      flex: 1,
      outline: 'none',

      available: {
        cursor: 'pointer',

        oneTime: {
          bg: 'black',
        },

        subscribe: {
          border: (t) => `1px solid ${t.colors.dark}`,
          bg: 'dark',
          '&:hover': {
            color: 'dark',
          },
        },
      },

      unavailable: {
        // cursor: 'default',
        oneTime: {
          variant: 'buttons.secondary',
          color: 'mediumDarkGray',
          // bg: 'gray',
          // border: t => `1px solid ${t.colors.gray}`,
          // '&:hover': {
          //   bg: 'gray',
          //   color: 'background'
          // }
        },

        subscribe: {
          bg: 'gray',
          border: (t) => `1px solid ${t.colors.dark}`,
          '&:hover': {
            bg: 'gray',
            color: 'background',
          },
        },
      },
    };

    this.quantityWrapper = {
      variant: 'flex.row.start.center',
      mr: 0,
      'input::-webkit-outer-spin-button, input::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      'input[type=number]': {
        MozAppearance: 'textfield',
      },
    };

    this.quantityButton = {
      cursor: 'pointer',
      width: '32px',
      height: '32px',
      minWidth: '32px',
      borderRadius: '50%',
      border: (t) => `1px solid ${t.colors.gray}`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'all 0.15s ease-in-out',
      ':hover': {
        borderColor: 'mediumDarkGray',
      },
    };

    this.buttonIcon = {
      width: '16px',
      color: 'text',
    };

    this.quantity = {
      variant: 'text.label.1',
      width: '34px',
      textAlign: 'center',
      mx: 5,
    };

    this.afterpay = {
      variant: 'flex.row.start.center',

      text: {
        color: 'mediumDarkGray',
        fontSize: [3, 4],
      },

      link: {
        ml: 2,
      },

      pill: {
        width: ['56px', '94px'],
        height: ['12px', '20px'],
        borderRadius: '10px',
        bg: '#B2FCE4',
        position: 'relative',
        overflow: 'hidden',
      },

      logo: {
        width: ['50px', '82px'],
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
      },
    };
  })()
);
